import React from "react";
import "../../../../style/components/whatsAppPreview.css";
import { whatsapp_brand } from "../../../../images/WhatsAppImages";
import { MdVerifiedUser, MdOutlineEmojiEmotions } from "react-icons/md";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { CiCirclePlus } from "react-icons/ci";
import { FaImages, FaMicrophone } from "react-icons/fa";
import { IoSearch } from "react-icons/io5";
import { BsThreeDotsVertical } from "react-icons/bs";
import { formatDateToCustomFormat } from "../../../Utils/Utils";
import { faArrowAltCircleLeft, faForward, faBackward, faGlobe, faPhone, faReply } from "@fortawesome/free-solid-svg-icons";
import styles from './PreviewRcsTemplate.module.css'
function PreviewRcsTemplate({ formData, setFormData }) {


    const next = () => {
        setFormData((prevData) => ({
            ...prevData, activeTabIndex: formData.activeTabIndex === formData.carousels.length - 1 ? 0 : formData.activeTabIndex + 1
        }))
    }

    const preView = () => {
        setFormData((prevData) => ({
            ...prevData, activeTabIndex: formData.activeTabIndex === 0 ? formData.carousels.length - 1 : formData.activeTabIndex - 1
        }))
    }

    return (
        <div className="card ">
            <div className="card-body">
                <div className="whatsapp">
                    <ul>
                        <li><strong> Template name: </strong> {formData.templateName}</li>
                        <li><strong> Sender ID : </strong> {formData.senderId} </li>
                        <li> <strong> Bot Message Type: </strong> {formData.botMessageType} </li>
                        <li><strong> Type: </strong> {formData.templateType} </li>
                    </ul>
                    <div

                        className={styles.container}
                    >
                        <div className={styles.deviceFrame}>



                            <div className={styles.rcsHeader}>
                                <div className='d-flex justify-content-center align-items-center'>
                                    {window.location.hostname === "console.authkey.io" && 
                                    <img src={whatsapp_brand} alt="" className={styles.brandImage} />}
                                    <span className='ml-2'>RCS</span>
                                </div>
                                <div className='d-flex justify-content-evenly align-items-center w-25'>
                                    <MdVerifiedUser />
                                    <IoSearch />
                                    <BsThreeDotsVertical />
                                </div>
                            </div>

                            <div className={styles.description}>
                                {window.location.hostname === "console.authkey.io" &&
                                    <img src={whatsapp_brand} alt="logo" className={styles.detailLogo} />
                                }
                                <div className="description w-75 text-center">Welcome! We're here to help. How can we assist you today?</div>
                            </div>

                            <div className={styles.deviceContent}>
                                <div className="d-flex justify-content-center w-100" style={{ fontSize: '.6rem' }}>
                                    {formatDateToCustomFormat(new Date())}
                                </div>

                                {formData.templateType === 'text' &&
                                    <div className="body-message">
                                        <p className="">
                                            {formData.content}
                                        </p>
                                    </div>
                                }

                                {formData.templateType === 'richcardcarousel' &&
                                    <div className="my-2 w-100 d-flex align-items-center justify-content-between">
                                        <div className="preView m-2">
                                            <FontAwesomeIcon onClick={preView} icon={faBackward} />
                                        </div>
                                        {
                                            formData.carousels.map((item, i) => {
                                                return (
                                                    <div key={i} className={`text-center ${formData.activeTabIndex === i ? null : "hide-current"}`} >
                                                        {item?.media?.file_type === "image" ?
                                                            <img className="img-fluid" src={item.media.url} />
                                                            : item.media?.file_type === "video" ? <video width="100%" controls>
                                                                <source src={item.media.url} type="video/mp4" />
                                                            </video>
                                                                :
                                                                null}
                                                        <h6 className="mt-2 rcs-title-preview">
                                                            {item.card_title}
                                                        </h6>
                                                        {/* <small>{item.card_description}</small> */}
                                                        <div className="body-message" style={{ overflowY: 'hidden' }}>
                                                            <p>{item.card_description}</p>

                                                        </div>

                                                        <>
                                                            {item.temp_suggestion.map((item, index) => (
                                                                item.type_of_action === 'reply' ?
                                                                    <div key={index} className="button-text border">
                                                                        <a href={`tel:+${item.countryCode}${item.phone}`}>
                                                                            <p>
                                                                                <FontAwesomeIcon icon={faReply} /> {item.suggestion_text}
                                                                            </p>
                                                                        </a>
                                                                    </div>
                                                                    :
                                                                    item.type_of_action === 'url_action' ?
                                                                        <div key={index} className="button-text border">
                                                                            <a href={`tel:+${item.countryCode}${item.phone}`}>
                                                                                <p>
                                                                                    <FontAwesomeIcon icon={faGlobe} /> {item.url}
                                                                                </p>
                                                                            </a>
                                                                        </div>
                                                                        :
                                                                        item.type_of_action === 'dialer_action' &&
                                                                        <div key={index} className="button-text border">
                                                                            <a href={`tel:+${item.countryCode}${item.phone}`}>
                                                                                <p>
                                                                                    <FontAwesomeIcon icon={faPhone} /> {item.phone_number}
                                                                                </p>
                                                                            </a>
                                                                        </div>
                                                            ))}
                                                        </>

                                                    </div>
                                                )
                                            })
                                        }

                                        <div className="preView m-2">
                                            <FontAwesomeIcon onClick={next} icon={faForward} />
                                        </div>
                                    </div>
                                }

                                {formData.templateType === 'richcardstandalone' &&
                                    <div className={`mt-2 w-100 d-flex flex-column justify-content-center
                                     ${formData?.standaloneCard.cardAlign === "left" ? 'align-items-start' :
                                            formData?.standaloneCard.cardAlign === "right" ? 'align-items-end' :
                                                ' align-items-center'}`}>
                                        {formData?.standaloneCard.media.file_type === "image" ?
                                            <img style={{ maxWidth: "80%" }} src={formData?.standaloneCard.media.url} />
                                            : formData?.standaloneCard.media.file_type === "video" ?
                                                <video width="100%" controls>
                                                    <source src={formData?.standaloneCard.media.url} type="video/mp4" />
                                                </video>
                                                :
                                                null
                                        }

                                        <h6 className="mt-2 rcs-title-preview">
                                            {formData?.standaloneCard.card_title}
                                        </h6>
                                        {/* <small>{formData?.standaloneCard.card_description}</small> */}
                                        <div className="body-message" style={{ overflowY: 'hidden' }}>
                                            <p>{formData?.standaloneCard.card_description}</p>

                                        </div>

                                        <>
                                            {formData?.standaloneCard?.temp_suggestion.map((item, index) => (
                                                item.type_of_action === 'reply' ?
                                                    <div key={index} className="button-text border">
                                                        <a href={`tel:+${item.countryCode}${item.phone}`}>
                                                            <p>
                                                                <FontAwesomeIcon icon={faReply} /> {item.suggestion_text}
                                                            </p>
                                                        </a>
                                                    </div>
                                                    :
                                                    item.type_of_action === 'url_action' ?
                                                        <div key={index} className="button-text border">
                                                            <a href={`tel:+${item.countryCode}${item.phone}`}>
                                                                <p>
                                                                    <FontAwesomeIcon icon={faGlobe} /> {item.url}
                                                                </p>
                                                            </a>
                                                        </div>
                                                        :
                                                        item.type_of_action === 'dialer_action' &&
                                                        <div key={index} className="button-text border">
                                                            <a href={`tel:+${item.countryCode}${item.phone}`}>
                                                                <p>
                                                                    <FontAwesomeIcon icon={faPhone} /> {item.phone_number}
                                                                </p>
                                                            </a>
                                                        </div>
                                            ))}
                                        </>
                                    </div>
                                }

                                {formData.suggestionsButton && (
                                    <>
                                        {formData.suggestionsButton.map((item, index) => (
                                            item.type_of_action === 'reply' ?
                                                <div key={index} className="button-text">
                                                    <a href={`tel:+${item.countryCode}${item.phone}`}>
                                                        <p>
                                                            <FontAwesomeIcon icon={faReply} /> {item.suggestion_text}
                                                        </p>
                                                    </a>
                                                </div>
                                                :
                                                item.type_of_action === 'url_action' ?
                                                    <div key={index} className="button-text">
                                                        <a href={`tel:+${item.countryCode}${item.phone}`}>
                                                            <p>
                                                                <FontAwesomeIcon icon={faGlobe} /> {item.url}
                                                            </p>
                                                        </a>
                                                    </div>
                                                    :
                                                    item.type_of_action === 'dialer_action' &&
                                                    <div key={index} className="button-text">
                                                        <a href={`tel:+${item.countryCode}${item.phone}`}>
                                                            <p>
                                                                <FontAwesomeIcon icon={faPhone} /> {item.phone_number}
                                                            </p>
                                                        </a>
                                                    </div>
                                        ))}
                                    </>
                                )}
                            </div>

                            <div className={styles.footer}>
                                <div className={styles.addOptions}>
                                    <CiCirclePlus />
                                    <FaImages />
                                </div>
                                <div className={styles.input}>
                                    <FaMicrophone className='mr-2' />
                                    <MdOutlineEmojiEmotions />
                                </div>
                            </div>



                        </div>

                    </div>
                </div>
            </div>
        </div >
    );
}

export default PreviewRcsTemplate;
